import { createFileRoute } from "@tanstack/react-router";
import { AuthRequired } from "@/components/auth/AuthRequired";
import { LeagueDetailView } from "@/components/rank/LeagueDetailView";
import { buildHead, SITE } from "@/lib/seo";

// League detail. Trailing `_` keeps it out of the /rank list layout so "Back"
// returns to the Private tab.
export const Route = createFileRoute("/_app/rank_/$leagueId")({
  // Private league — real title, kept out of search indexes.
  head: ({ params }) =>
    buildHead({
      path: `/rank/${params.leagueId}`,
      title: "League",
      description: `Private league standings on ${SITE.name}.`,
      noindex: true,
    }),
  component: LeagueDetailPage,
});

function LeagueDetailPage() {
  const { leagueId } = Route.useParams();
  return (
    <AuthRequired>
      <LeagueDetailView leagueId={leagueId} />
    </AuthRequired>
  );
}
